import { Box, Typography } from '@mui/material';

type Props = {
  label: string;
  value: string;
};

export const FieldInfo: React.FC<Props> = ({ label, value }) => {
  return (
    <Box
      display="flex"
      flexDirection="row"
      alignItems="flex-start"
      justifyContent="space-between"
    >
      <Typography variant="body1" color="text.secondary" fontWeight={400}>
        {label}
      </Typography>
      <Typography
        variant="body1"
        color="text.dark"
        fontWeight={400}
        maxWidth="60%"
        textAlign="end"
        style={{
          overflowWrap: 'break-word',
          whiteSpace: 'pre-line',
        }}
      >
        {value}
      </Typography>
    </Box>
  );
};
